import { equals } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const getPrevCuttingLinePathCommand = (self, ref_command) => {
  const idx = self._path_editor_list.findIndex(({ model }) =>
    equals(model)(ref_command)
  );
  return self._path_editor_list[idx - 1]?.model;
};
